<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.8、电机控制器温度</h3>

        <!-- ECharts 柱状图容器 -->
        <div ref="speedChart" class="chart-container" style="height: 280px;margin-top: 15px;"></div>
        <div class="table-caption">图表8</div>
        <!-- 横向多列表格（完全匹配截图） -->

        <el-table :data="speedTableData" size="mini" border :cell-class-name="tableCellClassName"
            style="width: 100%; margin-top: 15px;">
            <!-- 动态渲染列（车速区间） -->
            <el-table-column label="温度(℃)" align="center">
                <template slot-scope="scope">
                    {{ scope.row.speedLabel }}
                </template>
            </el-table-column>
            <!-- 时间列 -->
            <el-table-column label="时间(小时)" prop="time" align="center" />
            <!-- 百分比列 -->
            <el-table-column label="百分比(%)" prop="percent" align="center" />
        </el-table>
        <div class="table-caption">数据表8</div>

        <!-- 说明文本 -->
        <div class="note">

        </div>
    </div>
</template>

<script>

export default {
    name: "VehicleMcuTempertatureData",
    props: {
        motorTempChart: {
            type: Array,
            default: () => ([])
        }
    },
    watch: {
        motorTempChart: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.updateChart();
                }
            },
            deep: true
        }
    },
    data() {
        return {

            // 转换后的表格数据（按列组织）
            speedTableData: [

            ],
            myChart: undefined
        };
    },
    mounted() {
        this.initSpeedChart();
    },
    beforeDestroy() {
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
            this._resizeHandler = null;
        }
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null;
        }
    },
    methods: {
        updateChart() {
            var data = []
            var totalTime = 0;
            var xAxisData = [];
            var seriesData = [];
            this.motorTempChart.forEach(item => {

                data.push({
                    speedLabel: item.StandardName,
                    time: item.WorkHour,
                    percent: item.PointPerCent
                })
                totalTime += parseFloat(item.WorkHour);
                xAxisData.push(item.StandardName);
                seriesData.push(parseFloat(item.PointPerCent));
            })
            data.push({
                speedLabel: '累计',
                time: totalTime.toFixed(2),
                percent: '100'
            });

            this.speedTableData = data;

            const option = {
                xAxis: {
                    data: xAxisData,
                },
                series: [{
                    data: seriesData,
                }
                ]
            };

            this.myChart.setOption(option);
        },
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            // 对温度>100的区间应用警告样式
            if (columnIndex == 0)
                return "cell-header";

        },
        // 合并单元格方法
        initSpeedChart() {
            const chartDom = this.$refs.speedChart;
            this.myChart = echarts.init(chartDom);

            // 图表配置
            const option = {
                title: {
                    text: '',
                    left: 'center',

                },
                backgroundColor: '#E2F0FF',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                grid: {
                    left: '3%',
                    bottom: '8%',
                    right: '3%',
                    containLabel: true
                },
                xAxis: {
                    name: '温度(℃)',
                    nameLocation: 'center',
                    nameGap: 40,
                    type: 'category',
                    data: [],
                    axisLabel: {
                        rotate: 45,
                        interval: 0
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '百分比(%)'
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top'
                        },
                        itemStyle: {
                            color: '#409EFF' // 柱状图颜色（ElementUI 主色）
                        }
                    }
                ]
            };

            this.myChart.setOption(option);

            // 监听窗口 resize，自适应图表
            this._resizeHandler = () => {
                if (this.myChart) this.myChart.resize();
            };
            window.addEventListener('resize', this._resizeHandler);
        }
    }
};
</script>
<style scoped></style>